<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <tabs
        ref="tabs"
        :options="{ useUrlFragment: false, defaultTabHash: 'general' }"
        class="spl-edit-tabs">
        <tab id="defaultFilter" name="Edit/Create Adhoc Drive">
          <adhoc-drive-edit-page />
        </tab>
      </tabs>
      <div class="spl-adhoc-drive-edit-action-bar">
        <form-button
          style="grid-column: 1"
          @onClick="handleCancel">
          Cancel
        </form-button>
        <div style="grid-column: 2" />
        <form-button
          style="grid-column: 3"
          data-cy="adhoc-drive-edit-next"
          @onClick="handleNext">
          Save
        </form-button>
      </div>
      <div v-if="isLoading" class="spl-load-img" />
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { mapState, mapMutations, mapActions } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import { cloneDeep, isNumber } from 'lodash'
import moment from 'moment'
import store from '@/store'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      activeTab: 'defaultFilter',
      tabs: ['defaultFilter'],
      adhocDriveValues: {}
    }
  },
  computed: {
    ...mapState('adhocDrive', ['loadedAdhocDrive', 'currentEditAdhocDrive'])
  },
  beforeRouteEnter (to, from, next) {
    // load the adhocDrive before proceding when we enter an edit route
    if (to.name === 'adhoc-drive-edit') {
      store.dispatch('adhocDrive/loadAdhocDrive', to.params.id).then(() => {
        next()
      }).catch((error) => {
        next()
        window.bus.$emit('openErrorModal', error.ExceptionMessage)
      })
    } else {
      next()
    }
  },
  created () {
    this.adhocDriveValues = this.$route.params
    if (this.$route.name === 'adhoc-drive-create' && this.adhocDriveValues.Customer_ID) {
      this.setCurrentEditAdhocDrive({
        Customer_ID: this.adhocDriveValues.Customer_ID,
        Country_ID: this.adhocDriveValues.Country_ID,
        Provider_ID: this.adhocDriveValues.Provider_ID,
        From_City: this.adhocDriveValues.From_City,
        To_City: this.adhocDriveValues.To_City,
        Counter_Number: this.adhocDriveValues.Counter_Number,
        Description: this.adhocDriveValues.Description,
        Number_Of_Parcels: this.adhocDriveValues.Number_Of_Parcels,
        Weight: this.adhocDriveValues.Weight,
        Cost_Coverage_By: this.adhocDriveValues.Cost_Coverage_By,
        Agreed_Cost: this.adhocDriveValues.Agreed_Cost,
        Agreed_Price: this.adhocDriveValues.Agreed_Price,
        Currency_ID: this.adhocDriveValues.Currency_ID,
        Service_Leg_ID: this.adhocDriveValues.Service_Leg_ID,
        Comments: this.adhocDriveValues.Comments,
        AWB_Reference: this.adhocDriveValues.AWB_Reference,
        Forwarder_Reference: this.adhocDriveValues.Forwarder_Reference,
        Date_Of_Order: this.adhocDriveValues.Date_Of_Order
      })
    } else if (this.$route.name === 'adhoc-drive-create' && !this.adhocDriveValues.Customer_ID) {
      // Set a default adhocDrive when creating a new one
      this.setCurrentEditAdhocDrive({
        Customer_ID: -1,
        Country_ID: -1,
        Provider_ID: -1,
        From_City: '',
        To_City: '',
        Counter_Number: '',
        Description: '',
        Number_Of_Parcels: '',
        Weight: '',
        Cost_Coverage_By: 'time:matters',
        Agreed_Cost: '',
        Agreed_Price: '',
        Currency_ID: -1,
        Service_Leg_ID: -1,
        Comments: '',
        AWB_Reference: '',
        Forwarder_Reference: '',
        Date_Of_Order: moment().toISOString(true)
      })
    } else {
      this.setCurrentEditAdhocDrive(cloneDeep(this.loadedAdhocDrive))
    }
  },
  methods: {
    ...mapMutations('adhocDrive', ['setCurrentEditAdhocDrive']),
    ...mapActions('adhocDrive', ['saveAdhocDrive', 'loadAdhocDrive']),

    // ************************ Show Login is set to true if teh user is not logged in or if the token has expired.
    validateAndSend () {
      // Validate the adhocDrive before sending it
      var valid = true
      var validationMessage =''
      if (this.adhocDriveMissing()) {
        valid = false
        validationMessage = 'Please enter all required values -> Currency/Cost Coverage/Cost/Price'
      }
      if (this.adhocDriveNumberValues()) {
        valid = false
        validationMessage = 'Please check Agreed Cost, Agreed Price. At least one should have a numeric value!'
      }

      if (valid) {
        this.isLoading = true
        this.saveAdhocDrive(this.currentEditAdhocDrive).then((response) => {
          this.isLoading = false
          this.$router.back()
        }).catch((error) => {
          this.isLoading = false
          messageDialog('Something went wrong: ' + error.ExceptionMessage)
        })
      } else {
        messageDialog(validationMessage)
      }
    },
    adhocDriveMissing () {
      if (!this.currentEditAdhocDrive.Currency_ID ||
          !this.currentEditAdhocDrive.Cost_Coverage_By) {
        return true
      }
    },
    adhocDriveNumberValues () {
      if (isNaN(parseFloat(this.currentEditAdhocDrive.Agreed_Cost)) &&
        isNaN(parseFloat(this.currentEditAdhocDrive.Agreed_Price))) {
        return true
      }
    },
    // *********************** Handle Actionbar *************************
    handleNext () {
      var adhocDrive = cloneDeep(this.currentEditAdhocDrive)
      adhocDrive.Date_Of_Order = adhocDrive.Adhoc_Filter.Date_Of_Order
      adhocDrive.Counter_Number = adhocDrive.Adhoc_Filter.Counter_Number
      adhocDrive.Country_ID = adhocDrive.Adhoc_Filter.Country_ID.value
      adhocDrive.Provider_ID = adhocDrive.Adhoc_Filter.Provider_ID.value ? adhocDrive.Adhoc_Filter.Provider_ID.value : 1
      adhocDrive.Customer_ID = adhocDrive.Adhoc_Filter.Customer_ID.value
      adhocDrive.From_City = adhocDrive.Adhoc_Filter.From_City
      adhocDrive.To_City = adhocDrive.Adhoc_Filter.To_City
      adhocDrive.Description = adhocDrive.Adhoc_Filter.Description
      adhocDrive.Number_Of_Parcels = adhocDrive.Adhoc_Filter.Number_Of_Parcels
      adhocDrive.Weight = adhocDrive.Adhoc_Filter.Weight
      adhocDrive.Cost_Coverage_By = adhocDrive.Adhoc_Filter.Cost_Coverage_By
      adhocDrive.Agreed_Cost = adhocDrive.Adhoc_Filter.Agreed_Cost
      adhocDrive.Agreed_Price = adhocDrive.Adhoc_Filter.Agreed_Price
      adhocDrive.Currency_ID = adhocDrive.Adhoc_Filter.Currency_ID.value
      adhocDrive.Comments = adhocDrive.Adhoc_Filter.Comments
      adhocDrive.AWB_Reference = adhocDrive.Adhoc_Filter.AWB_Reference
      adhocDrive.Forwarder_Reference = adhocDrive.Adhoc_Filter.Forwarder_Reference
      adhocDrive.Service_Leg_ID = adhocDrive.Adhoc_Filter.Service_Leg_ID.value
      delete adhocDrive.Adhoc_Filter
      this.setCurrentEditAdhocDrive(cloneDeep(adhocDrive))
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-edit-tabs {
    background-color: #fff7e7;
    .tabs-component-panels {
      padding: 0 $mainPadding;
    }
    .tabs-component-tabs {
      background-color: $yellowButtonLabelHover;
      padding: 3px $mainPadding 13px $mainPadding;
      margin: 0;
      display: flex;
      .tabs-component-tab {
        color: white;
        padding-bottom: 5px;
        margin: 12px 10px 0 10px;
        list-style: none;
        font-size: 14px;
        &.is-active {
          color: #ebaa28;
          border-bottom: 2px solid #ebaa28;
        }
      }
    }
  }
</style>
